import React from "react";
import type { ChatBoxWindowInfo } from "../types";
import { ChatBoxWindowContext } from "../context/chat-box-window.context";

export const useChatBoxWindowInfo = (): ChatBoxWindowInfo => {
	return React.useContext(ChatBoxWindowContext);
};
